import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// INTERFACES
import { ISelect } from '../../interfaces/Select.interface';

export const Container = styled.div`
  display: inline-flex;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 16px;
  flex-direction: column;
`;

export const Label = styled.label<ISelect>`
  display: inline-block;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  color: ${theme.colors.secondary.gray100};
  font-size: 12px;
  line-height: 22px;
  ${({ isErroredExternal }) =>
    isErroredExternal &&
    `
    color: ${theme.colors.secondary.gray200};
  `}
  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: ${theme.colors.secondary.gray300};
  `}
`;

export const SubLabelText = styled.p<ISelect>`
  display: flex;
  justify-content: space-between;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  color: ${theme.colors.secondary.gray300};
  margin: 0 0 8px 0;
`;

export const SelectContainer = styled.div`
  display: block;
`;

export const Error = styled.span`
  display: flex;
  color: ${theme.colors.secondary.red200};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 8px;
`;

export const defaultStyles = {
  control: (styles: any, state: any) => ({
    ...styles,
    width: '100%',
    borderRadius: '8px',
    padding: '11px 16px',
    backgroundColor: state.isDisabled ? theme.colors.secondary.gray600 : theme.colors.primary.white,
    border: `1px solid ${state.isErroredExternal ? theme.colors.secondary.red200 : theme.colors.secondary.gray500}`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid ${theme.colors.secondary.blue200}`,
      boxShadow: `0px 0px 0px 2px ${theme.colors.secondary.blue500}`
    },
    height: '58px',
  }),
  valueContainer: () => ({
    padding: 0,
    fontFamily: 'Clan Pro',
    fontWeight: theme.weights.regular,
    fontSize: '14px',
    lineHeight: '24px',
    color: theme.colors.secondary.gray300,
    display: 'flex',
    alignItems: 'center',
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    display: 'flex',
    alignItems: 'center',
    '> div:last-child': {
      padding: 0,
      path: {
        fill: state.isDisabled
          ? theme.colors.secondary.gray300
          : state.isFocused
          ? theme.colors.secondary.blue200
          : theme.colors.primary.black
      }
    }
  }),
  menuList: (styles: any) => ({
    ...styles,
    flexDirection: 'column',
    width: '100%',
    padding: 0,
    borderRadius: '8px'
  }),
  menu: () => ({
    marginTop: '8px',
    border: `1px solid ${theme.colors.primary.transparentBg}`,
    borderRadius: '8px',
    boxShadow: '0px 10px 30px 10px rgba(0, 0, 0, 0.07)',
    position: 'absolute',
    width: '100%',
    zIndex: 1000
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    flexDirection: 'column',
    fontFamily: 'Clan Pro',
    fontWeight: state.isSelected ? theme.weights.semibold : theme.weights.regular,
    fontSize: '13px',
    lineHeight: '24px',
    padding: '8px 24px',
    color: theme.colors.secondary.gray100,
    backgroundColor: theme.colors.primary.white,
    position: 'relative',
    '&:hover': {
      backgroundColor: theme.colors.primary.lightGray,
      color: theme.colors.primary.black
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '8px',
      height: '8px',
      display: state.isSelected ? 'block' : 'none',
      background: theme.colors.secondary.blue200,
      borderRadius: '4px',
      top: '16px',
      right: '29px'
    }
  })
};
